import * as types from '../common/types'
import createReducer from './createReducer'

const initialState = {
  carePlanSortType: null,
  historyDateRange: {
    startDate: null,
    endDate: null,
  },
  riskAssessmentSortType: null,
}

export const carePlans = createReducer(initialState, {
  [types.SET_RESIDENT_ADLS](state, { adls }) {
    return {
      ...state,
      adls,
    }
  },
  [types.SET_CARE_PLAN_SORT_TYPE](state, { carePlanSortType }) {
    return {
      ...state,
      carePlanSortType,
    }
  },
  [types.SET_CARE_PLAN_HISTORY](state, { history }) {
    return {
      ...state,
      history,
    }
  },
  [types.SET_CARE_PLAN_HISTORY_DATE_RANGE](state, { historyDateRange }) {
    return {
      ...state,
      historyDateRange,
    }
  },
  [types.SET_RISK_ASSESSMENT_SORT_TYPE](state, { riskAssessmentSortType }) {
    return {
      ...state,
      riskAssessmentSortType,
    }
  },
})
